import React from 'react';

import { tv } from '@/utils/styles';

export interface TagTriggerTagProps {
  title?: string;
  label?: string;
  icon?: React.ReactNode;
}

const TagTriggerTag = ({ title, label, icon }: TagTriggerTagProps) => {
  const { base, text, iconWrapper } = styles();

  return (
    <div title={title} className={base()}>
      {icon ? (
        <div className={iconWrapper()}>
          {icon}
          <span className={text()}>{label}</span>
        </div>
      ) : (
        <span className={text()}>{label}</span>
      )}
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'flex h-5 max-w-24 items-center rounded-sm bg-grey-200 px-1.5 text-sm leading-none',
    text: 'min-w-0 overflow-hidden overflow-ellipsis whitespace-nowrap leading-loose',
    iconWrapper: 'flex items-center gap-1 overflow-hidden',
  },
});

export { TagTriggerTag };
